export const getDisplayNames = (items, languagePrefix) =>
  items.map((item) =>
    item[`displayName_${languagePrefix}`]
      ? item[`displayName_${languagePrefix}`]
      : item.displayName,
  );
